// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1sTsT","title":"BackImages_title__1noxP","images":"BackImages_images__3ojt6"};